import { render, staticRenderFns } from "./ProductionActionLayout.vue?vue&type=template&id=f6284c52&scoped=true&"
import script from "./ProductionActionLayout.vue?vue&type=script&lang=js&"
export * from "./ProductionActionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6284c52",
  null
  
)

export default component.exports